/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomContractVariableValueDto } from './CustomContractVariableValueDto';
import {
    CustomContractVariableValueDtoFromJSON,
    CustomContractVariableValueDtoFromJSONTyped,
    CustomContractVariableValueDtoToJSON,
    CustomContractVariableValueDtoToJSONTyped,
} from './CustomContractVariableValueDto';
import type { CustomContractFeesDto } from './CustomContractFeesDto';
import {
    CustomContractFeesDtoFromJSON,
    CustomContractFeesDtoFromJSONTyped,
    CustomContractFeesDtoToJSON,
    CustomContractFeesDtoToJSONTyped,
} from './CustomContractFeesDto';
import type { CustomContractGuaranteeDto } from './CustomContractGuaranteeDto';
import {
    CustomContractGuaranteeDtoFromJSON,
    CustomContractGuaranteeDtoFromJSONTyped,
    CustomContractGuaranteeDtoToJSON,
    CustomContractGuaranteeDtoToJSONTyped,
} from './CustomContractGuaranteeDto';

/**
 * 
 * @export
 * @interface CreateSingleQuoteCommand
 */
export interface CreateSingleQuoteCommand {
    /**
     * Unique identifier of the simulation
     * @type {string}
     * @memberof CreateSingleQuoteCommand
     */
    riskId?: string;
    /**
     * Unique identifier of the tunnel configuration
     * @type {string}
     * @memberof CreateSingleQuoteCommand
     */
    funnelId: string;
    /**
     * Indicates if the quote is for an individual or not
     * @type {boolean}
     * @memberof CreateSingleQuoteCommand
     */
    isIndividual?: boolean;
    /**
     * Associated contract identifier
     * @type {string}
     * @memberof CreateSingleQuoteCommand
     */
    contractIdentifier?: string | null;
    /**
     * Support code of the pricing card (SOLO, GROUP or CADRE); the on-the-fly quote is priced on it
     * @type {string}
     * @memberof CreateSingleQuoteCommand
     */
    supportCode?: string | null;
    /**
     * Custom fees for the tunnel
     * @type {Array<CustomContractFeesDto>}
     * @memberof CreateSingleQuoteCommand
     */
    fees?: Array<CustomContractFeesDto>;
    /**
     * Custom variables for the tunnel
     * @type {Array<CustomContractVariableValueDto>}
     * @memberof CreateSingleQuoteCommand
     */
    variables?: Array<CustomContractVariableValueDto>;
    /**
     * Selected guarantees for the quote
     * @type {Array<CustomContractGuaranteeDto>}
     * @memberof CreateSingleQuoteCommand
     */
    guarantees?: Array<CustomContractGuaranteeDto>;
    /**
     * Nature branch code classification
     * @type {string}
     * @memberof CreateSingleQuoteCommand
     */
    branchCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSingleQuoteCommand
     */
    personId: string;
}

/**
 * Check if a given object implements the CreateSingleQuoteCommand interface.
 */
export function instanceOfCreateSingleQuoteCommand(value: object): value is CreateSingleQuoteCommand {
    if (!('funnelId' in value) || value['funnelId'] === undefined) return false;
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    return true;
}

export function CreateSingleQuoteCommandFromJSON(json: any): CreateSingleQuoteCommand {
    return CreateSingleQuoteCommandFromJSONTyped(json, false);
}

export function CreateSingleQuoteCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSingleQuoteCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'funnelId': json['funnelId'],
        'isIndividual': json['isIndividual'] == null ? undefined : json['isIndividual'],
        'contractIdentifier': json['contractIdentifier'] == null ? undefined : json['contractIdentifier'],
        'supportCode': json['supportCode'] == null ? undefined : json['supportCode'],
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(CustomContractFeesDtoFromJSON)),
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(CustomContractVariableValueDtoFromJSON)),
        'guarantees': json['guarantees'] == null ? undefined : ((json['guarantees'] as Array<any>).map(CustomContractGuaranteeDtoFromJSON)),
        'branchCode': json['branchCode'],
        'personId': json['personId'],
    };
}

export function CreateSingleQuoteCommandToJSON(json: any): CreateSingleQuoteCommand {
    return CreateSingleQuoteCommandToJSONTyped(json, false);
}

export function CreateSingleQuoteCommandToJSONTyped(value?: CreateSingleQuoteCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'funnelId': value['funnelId'],
        'isIndividual': value['isIndividual'],
        'contractIdentifier': value['contractIdentifier'],
        'supportCode': value['supportCode'],
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(CustomContractFeesDtoToJSON)),
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(CustomContractVariableValueDtoToJSON)),
        'guarantees': value['guarantees'] == null ? undefined : ((value['guarantees'] as Array<any>).map(CustomContractGuaranteeDtoToJSON)),
        'branchCode': value['branchCode'],
        'personId': value['personId'],
    };
}

